/**
 * @file: useLeadDetail.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCachedQuery } from '@euler/functions/useCachedQuery';
import { LeadDetail } from '@euler/model/lead/types';
import { useServiceFactory } from '@euler/services/factory';

export const useLeadDetail = (leadId: string) => {
  const { leadService } = useServiceFactory();
  return useCachedQuery<LeadDetail>(
    `leads/${leadId}.detail.json`,
    30,
    async () => {
      return await leadService.getDetail(leadId);
    },
  );
};
